<template>
	<div class="modularContent">
		<div class="contentbox">

			<div class="bodybox">
				<div class="PatentNature" style="margin-top: 40px;">
					<div style="display: flex;">
						<div>产权性质：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>提交方式：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>提交方式：</div>
						<div class="inputbox"></div>
					</div>
				</div>
				<div class="PatentNature">
					<div style="display: flex;">
						<div>提交日期： </div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>授权日期：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div></div>
						<div class="querybtn">查询</div>
						<div class="emptybtn">清空</div>
					</div>

				</div>

			</div>
		</div>
		<div class="tu1img" >
			<Tu2></Tu2>
		</div>
		<div class="tu1img" >
			<Tu1></Tu1>
		</div>
	</div>
</template>

<script>
	import Tu1 from './echartsUI/tu1/index.vue'
	import Tu2 from './echartsUI/tu2/index.vue'
	export default {
		name: "",
		data() {
			return {
				datalist:[
					{text:31.7},
					{text:26.8},
					{text:18.8},
					{text:6.24},
				]
			}
		},
		components: {
			Tu1,Tu2
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style scoped lang="less">
	.modularBox>.modularContent {
		width: 95%;
		height: 95%;
		margin: 0 auto;
		margin-top: 20px;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.modularBox>.modularContent::-webkit-scrollbar {
		width: 0;
	}

	.contentbox {
		background: #FFFFFF;
		overflow: hidden;
	}

	/*内容盒子里的内容*/
	.bodybox {
		width: 100%;
		margin: 0 auto;
		// margin-top: 26px;
		overflow: hidden;
		/*border: 1px red solid;*/
		overflow: hidden;
	}

	.bodybox>div {
		margin-top: 10px;
		display: flex;
		font-size: 14px;

	}

	.bodybox>.PatentNature {
		width: 98%;
		margin: 0 auto;
		margin-top: 20px;
	}

	.bodybox>.PatentNature>div {
		width: calc((100% - 0px)/3);
		line-height: 28px;
		/*margin-right: 20px;*/
	}

	.bodybox>.PatentNature>div>div:first-child {
		width: 80px;
		text-align: right;
	}

	.bodybox>.PatentNature>div>.inputbox {
		width: 273px;
		height: 28px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
		line-height: 28px;
		padding-left: 4px;
		color: #A0A0A0;
		font-size: 14px;
	}

	.querybtn {
		width: 56px;
		height: 28px;
		background: #094AAE;
		border-radius: 5px;
		line-height: 28px;
		text-align: center;
		color: #FFFFFF;
	}

	.PatentNature .emptybtn {
		margin-left: 20px;
	}

	.emptybtn {
		width: 56px;
		height: 28px;
		background: #4D8F00;
		border-radius: 5px;
		line-height: 28px;
		text-align: center;
		color: #FFFFFF;
	}

	/* table */
	.tablebox {
		width: 1068px;
		margin: 0 auto;
		border-top: 1px solid #E5E5E5;
		border-right: 1px solid #E5E5E5;
		border-left: 1px solid #E5E5E5;
	}

	/deep/.el-table__header th {
		padding: 0;
		line-height: 40px;
		height: 40px;
		background: #D8D8D8;
		font-weight: bold;
		color: #333333;
		font-size: 14px;

	}

	/deep/ .el-table__body td {
		padding: 0;
		height: 40px;
		line-height: 40px;
		color: #333333;
		font-size: 14px;
	}

	.btnbox {
		width: 100%;
		border-top: 1px solid #E5E5E5;
		padding: 10px;

		div {
			margin-left: 20px;
		}
	}

	.fenye {
		float: right;
		margin-right: 40px;
	}

	.el-pagination {
		margin-top: 10px;
	}
	
	
	.tu1img{
		
		margin: 13vh auto;
	}
	.yuanbox{
		width: 120px;
		height: 120px;
		line-height: 120px;
		text-align: center;
	}
	.bigyuanbox>.yuanbox{
		display: inline-block;
		margin-top: 3vh;
	}
	.bigyuanbox>div:nth-child(2){
		background: url('~@/assets/backPage/编组 22.png')  no-repeat center;
		background-size: 100% 100%;
	}
	.bigyuanbox>div:nth-child(3){
		background: url('~@/assets/backPage/编组 22(1).png')  no-repeat center;
		background-size: 100% 100%;
	}
	.bigyuanbox>div:nth-child(4){
		background: url('~@/assets/backPage/编组 22(2).png')  no-repeat center;
		background-size: 100% 100%;
	}
	.bigyuanbox>div:nth-child(5){
		background: url('~@/assets/backPage/编组 22(3).png')  no-repeat center;
		background-size: 100% 100%;
	}
</style>
